import containerTemplate from "../../../containers/template";
import TemplateChoosing from "./TemplateChoosing";

export default containerTemplate(TemplateChoosing);
